import { useOnValueChange } from '@calendly/hooks'
import { compact, isEqual } from 'lodash-es'
import { useState } from 'react'

const mapSectionToDisplay = (section) => ({ ...section, display: true })

const getNonRemovedSections = (sectionsToDisplay) => [...sectionsToDisplay].filter(({ remove }) => !remove)
const isAnyRemovedSections = (sectionsToDisplay) => sectionsToDisplay.some(({ remove }) => remove)

const getSectionsToAdd = (currentKeys, updatedSections) => compact(updatedSections.map((section, idx) => {
  if (!currentKeys.includes(section.key)) {
    return mapSectionToDisplay(section, updatedSections[idx - 1])
  }
  return null
}))

const markSectionsToAnimateOut = (sectionsToDisplay, visibleSections) => {
  sectionsToDisplay.forEach((section) => {
    if (!visibleSections.includes(section.key)) {
      section.display = false
    }
  })
}

const markSectionsToImmediatelyRemove = (sectionsToDisplay) => {
  sectionsToDisplay.forEach((section, idx) => {
    if (!section.display && sectionsToDisplay.slice(idx).some(({ display }) => display)) {
      section.display = true
      section.remove = true
    }
  })
}

export const useDisplaySections = (selectedSections) => {
  const [sectionsToDisplay, setSectionsToDisplay] = useState(
    selectedSections.slice().reverse().map(mapSectionToDisplay)
  )

  useOnValueChange(selectedSections, () => {
    const currentKeys = sectionsToDisplay.filter(({ display, remove }) => display && !remove).map(({ key }) => key)
    const updatedSections = selectedSections.slice().reverse()
    const updatedKeys = updatedSections.map(({ key }) => key)

    if (!isEqual(currentKeys, updatedKeys)) {
      let updatedSectionsToDisplay = getNonRemovedSections(sectionsToDisplay)

      updatedSectionsToDisplay = updatedSectionsToDisplay.concat(getSectionsToAdd(currentKeys, updatedSections))

      markSectionsToAnimateOut(updatedSectionsToDisplay, updatedKeys)
      markSectionsToImmediatelyRemove(updatedSectionsToDisplay)

      setSectionsToDisplay(updatedSectionsToDisplay)
    }
  })

  const cleanSections = () => {
    if (isAnyRemovedSections(sectionsToDisplay)) {
      setSectionsToDisplay(getNonRemovedSections(sectionsToDisplay))
    }
  }

  const removeSection = (sectionkey) => {
    setSectionsToDisplay(getNonRemovedSections(sectionsToDisplay).filter(({ key }) => sectionkey !== key))
  }

  return [sectionsToDisplay, cleanSections, removeSection]
}
